import React from "react";
import Slider from "react-slick";
import { ParamIcon } from "../../../assets/icons/ParamIcon";
import { AccompagnementIcon } from "../../../assets/icons/AccompagnementIcon";
import { TimeIcon } from "../../../assets/icons/TimeIcon";
import { CertifIcon } from "../../../assets/icons/CertifIcon";
import { GarantieIcon } from "../../../assets/icons/GarantieIcon";
import "./index.scss";
export const Engagements = () => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 1000,
    arrows: false, // Direction de droite à gauche
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 1500, // En dessous de 768px (mobile)
        settings: {
          slidesToShow: 4, // Affiche 3 drapeaux
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 992,
        settings: { slidesToShow: 2, slidesToScroll: 1 },
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 1, slidesToScroll: 1 },
      },

      {
        breakpoint: 480, // En dessous de 480px (petit mobile)
        settings: {
          slidesToShow: 1, // Affiche 2 drapeaux
          slidesToScroll: 1,
        },
      },
    ],
  };
  const engagements = [
    {
      icon: <CertifIcon />,
      title:
        "Entreprise certifiée RGE Qualibat pour garantir vos aides financières.",
    },
    {
      icon: <ParamIcon />,
      title: "Travaux réalisés dans les règles de l’art",
    },
    {
      icon: <GarantieIcon />,
      title: "Garantie décennale sur tous nos chantiers",
    },
    {
      icon: <TimeIcon />,
      title: "Respect des délais et propreté du chantier.",
    },
    {
      icon: <AccompagnementIcon />,
      title: "Accompagnement administratif (aides, dossiers copropriété)",
    },
  ];
  return (
    <div className="Engagements">
      <div className="Engagements-header mb-5">
        <h1>
          Nos <br className="d-none d-md-block" /> engagements
        </h1>
        <p className="mt-3">
          Améliorer le confort thermique, valoriser les biens immobiliers et
          permettre à nos clients de profiter des aides financières disponibles
          pour la transition énergétique.
        </p>
      </div>
      <Slider {...settings}>
        {engagements.map((engagement, index) => (
          <div className="Engagements-card " key={index}>
            <div className="icon">{engagement.icon}</div>
            <h5 className="mt-3">{engagement.title}</h5>
          </div>
        ))}
      </Slider>
    </div>
  );
};
